"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributesIgnoredForVariants = void 0;
const shared_types_1 = require("@merchx-v2/shared-types");
exports.attributesIgnoredForVariants = [
    shared_types_1.ATTRIBUTE_TYPE.ARTWORK_ORIGINAL,
    shared_types_1.ATTRIBUTE_TYPE.ARTWORK_PREVIEW,
    shared_types_1.ATTRIBUTE_TYPE.CG_PRODUCT_VARIANT_ID,
    shared_types_1.ATTRIBUTE_TYPE.CG_TEXTUAL_PRODUCT_ID,
    shared_types_1.ATTRIBUTE_TYPE.DTG_CAMPAIGN_ID,
    shared_types_1.ATTRIBUTE_TYPE.DTG_PRODUCT_ID,
    shared_types_1.ATTRIBUTE_TYPE.ORDER_STATE,
    shared_types_1.ATTRIBUTE_TYPE.SUBSCRIPTION_INTERVAL,
    shared_types_1.ATTRIBUTE_TYPE.SUBSCRIPTION_REPEAT_FREQUENCY,
    shared_types_1.ATTRIBUTE_TYPE.VARIANT
];
//# sourceMappingURL=attributesIgnoredForVariants.js.map